var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPostOffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE1\x84\x80\xE1\x85\xB3\xE1\x86\xB7\xE1\x84\x8B\xE1\x85\xB2\xE1\x86\xBC\xE1\x84\x8B\xE1\x85\xA1\xE1\x84\x8B\xE1\x85\xB5\xE1\x84\x8F\xE1\x85\xA9\xE1\x86\xAB_SVG_\xE1\x84\x8B\xE1\x85\xAE\xE1\x84\x8E\xE1\x85\xA6\xE1\x84\x80\xE1\x85\xAE\xE1\x86\xA8 1",
    clipPath: "url(#clip0_1736_10049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 24C19.1274 24 24.5 18.6274 24.5 12C24.5 5.37258 19.1274 0 12.5 0C5.87258 0 0.5 5.37258 0.5 12C0.5 18.6274 5.87258 24 12.5 24Z",
    fill: "#FF0C00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.12376 11.9715C4.11528 11.9741 4.10819 11.9799 4.10403 11.9878C4.09986 11.9956 4.09897 12.0048 4.10153 12.0132C4.10293 12.0182 4.10544 12.0228 4.10886 12.0266C4.11229 12.0305 4.11655 12.0335 4.12131 12.0355L6.71331 13.7466L7.45576 10.2539L4.12376 11.9715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.4705 10.252H18.8148C18.7743 10.2538 18.7346 10.2638 18.6981 10.2813L15.4125 11.9744C15.3819 11.9882 15.3808 12.0175 15.4092 12.0366L17.9579 13.7137C17.9928 13.7337 18.0319 13.745 18.0721 13.7468H18.7274C18.7614 13.7468 18.7652 13.7326 18.7374 13.7137L16.1363 12.0026L19.4776 10.2813C19.5079 10.2664 19.5036 10.252 19.4705 10.252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.0681 10.252H13.5001L12.7583 13.7468H17.3241C17.3587 13.7468 17.3621 13.7326 17.3341 13.7137L14.7374 12.0026L18.0734 10.2813C18.1036 10.2664 18.1001 10.252 18.0681 10.252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20.8718 10.252H20.2165C20.1761 10.254 20.1364 10.2639 20.0998 10.2813L16.8147 11.9744C16.7845 11.9882 16.7841 12.0175 16.8118 12.0366L19.3607 13.7137C19.3952 13.7339 19.4341 13.7453 19.4741 13.7468H20.132C20.1656 13.7468 20.1709 13.7326 20.1416 13.7137L17.54 12.0026L20.8803 10.2817C20.9096 10.2664 20.9067 10.252 20.8718 10.252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M17.8639 7.96875H7.11475C6.51475 7.96875 6.0952 8.34653 5.99542 8.81319C5.96905 8.93172 5.9777 9.05536 6.0203 9.16906C6.06291 9.28276 6.13765 9.38163 6.23542 9.45364L10.0999 12.0008H10.1028L17.871 7.99475C17.9019 7.97853 17.8999 7.96875 17.8639 7.96875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M16.1593 16L10.0998 12L5.15576 14.5502C4.89265 14.7058 4.69843 14.9342 4.64465 15.19C4.54421 15.6567 4.80287 16.0344 5.40399 16.0344H16.1478C16.1829 16.0344 16.1887 16.0196 16.1593 16Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1736_10049"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostOffice);
export default __webpack_public_path__ + "static/media/post-office.1af6f6f696276960d275b507f26280e9.svg";
export { ForwardRef as ReactComponent };